module.exports = __webpack_public_path__ + "plus-button.svg?c4fa4bc671a054595ca1276b5ffbb8a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plus-button.svg
// module id = 646
// module chunks = 0